import { createAction } from '@reduxjs/toolkit';
import { SET_STAGES_LIST } from '../actionConstants';

export const setStagesListAction = createAction(SET_STAGES_LIST);
